/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerEnquiry as ModelsCustomerCustomerEnquiry } from '../../models/Models/Customer/customer-enquiry';
import { CustomerEnquiryResponse as ModelsCustomerCustomerEnquiryResponse } from '../../models/Models/Customer/customer-enquiry-response';

export interface V4CustomersMeEnquiryPost$Json$Xml$Params {
      body?: ModelsCustomerCustomerEnquiry
}

export function v4CustomersMeEnquiryPost$Json$Xml(http: HttpClient, rootUrl: string, params?: V4CustomersMeEnquiryPost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>> {
  const rb = new RequestBuilder(rootUrl, v4CustomersMeEnquiryPost$Json$Xml.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>;
    })
  );
}

v4CustomersMeEnquiryPost$Json$Xml.PATH = '/v4/customers/me/enquiry';
